import { render, staticRenderFns } from "./ChannelStylesCopyModal.vue?vue&type=template&id=3dc03323&"
import script from "./ChannelStylesCopyModal.vue?vue&type=script&lang=ts&"
export * from "./ChannelStylesCopyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports